// For Repository PresetAssociation

import type { AsyncData } from '#app';
import type { IModelResponse } from '~/services/base/dto/base.dto';
import type { IModelGETPresetAssociationPresetResponse, IModelPresetActiveResponse } from './dto/preset-asso.dto';

export class PresetAssociationRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService
  }

  async getPresetAssociationPreset(id: string): Promise<AsyncData<IModelResponse<IModelGETPresetAssociationPresetResponse>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/preset-association/preset/${id}`, this.configService);
    return dataResult;
  }

  async postPresetAssociationPreset(formData: FormData): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/preset-association/preset`, this.configService, {
      method: 'POST',
      body: formData
    });
    return dataResult;
  }
  async putPresetAssociationPreset(formData: FormData): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/preset-association/preset`, this.configService, {
      method: 'PUT',
      body: formData
    });
    return dataResult;
  }

  async getPresetAssociationPresetActive(params: any): Promise<AsyncData<IModelResponse<IModelPresetActiveResponse[]>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/preset-association/preset-active`, this.configService, {
      params,
    });
    return dataResult;
  }

  async updatePresetAssociationBeginningMessageFavorite(params: any): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/preset-message-begin`, this.configService, {
      method: 'PUT',
      body: {
        data: params
      }
    });
    return dataResult;
  }
}
